import React from 'react';
import LegacyCheckbox, { CheckboxProps } from './Checkbox.legacy';
import AlphaCheckbox from './Checkbox.alpha';

const Component = process.env.IS_LEGACY ? LegacyCheckbox : AlphaCheckbox;
export default Component as React.FC<CheckboxProps>;
export type { CheckboxProps };
